import { useContext, useEffect } from 'react';
import messages from 'messages';
import usePostMessage from 'hooks/utils/usePostMessage';
import { useIntl } from 'react-intl';
import { Panel } from 'components/panel';
import { ROUTE_USER_ENTITY_DOCUMENTS } from 'routes/RouteList';
import { useParams, useRouteMatch } from 'react-router-dom';
import { StoreContext } from 'index';
import useFiles from 'hooks/queries/useFiles';
import Loader from 'components/loader/Loader';
import RetryPanel from 'containers/partials/error-boundary/RetryPanel';
import DocumentsList from './DocumentsList';

function Documents() {
  const intl = useIntl();
  const {
    authStore: {
      user: { id }
    }
  } = useContext(StoreContext);
  const { entityId } = useParams();

  const active = useRouteMatch([ROUTE_USER_ENTITY_DOCUMENTS]);
  const { sendMessage } = usePostMessage();

  const { files, loading, error, getFiles, sortFiles } = useFiles({
    entityId,
    linkId: id
  });

  useEffect(() => {
    getFiles();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const data = {
      title: intl.formatMessage(messages.documents),
      description: intl.formatMessage(messages.documentsSubtitleAll),
      canGoBack: false
    };
    sendMessage({ message: data });
  }, []);

  return (
    <Panel active={active?.isExact}>
      {loading && <Loader />}
      {error && <RetryPanel />}

      <DocumentsList entityId={entityId} files={files} sortFiles={sortFiles} />
    </Panel>
  );
}

export default Documents;
